"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orangeOnly = exports.greenOnly = exports.blueOnly = exports.pageColorThemeOnly = void 0;
var common_mfe_1 = require("../../mfe/common-mfe");
var Themes_style_1 = require("../Themes.style");
function pageColorThemeOnly(themeFunction) {
    return "\n    ".concat(blueOnly(themeFunction), "\n    ").concat(greenOnly(themeFunction), "\n    ").concat(orangeOnly(themeFunction), "\n  ");
}
exports.pageColorThemeOnly = pageColorThemeOnly;
function blueOnly(themeFunction) {
    var pageColor = Themes_style_1.PageColors[common_mfe_1.PAGE_COLORS.BLUE];
    return "\n    .".concat((0, common_mfe_1.getPageColorThemeClass)(common_mfe_1.PAGE_COLORS.BLUE), " & {\n      ").concat(themeFunction(pageColor), "\n    }\n  ");
}
exports.blueOnly = blueOnly;
function greenOnly(themeFunction) {
    var pageColor = Themes_style_1.PageColors[common_mfe_1.PAGE_COLORS.GREEN];
    return "\n    .".concat((0, common_mfe_1.getPageColorThemeClass)(common_mfe_1.PAGE_COLORS.GREEN), " & {\n      ").concat(themeFunction(pageColor), "\n    }\n  ");
}
exports.greenOnly = greenOnly;
function orangeOnly(themeFunction) {
    var pageColor = Themes_style_1.PageColors[common_mfe_1.PAGE_COLORS.ORANGE];
    return "\n    .".concat((0, common_mfe_1.getPageColorThemeClass)(common_mfe_1.PAGE_COLORS.ORANGE), " & {\n      ").concat(themeFunction(pageColor), "\n    }\n  ");
}
exports.orangeOnly = orangeOnly;
